// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"72f68aeb","452":"fd1b08f9","649":"1edc6440","744":"eec74659"}[chunkId] + ".chunk.js";
};